<ng-container *ngIf="pageScope$ | async as scope">
  <yo-breadcrumbs
    *ngIf="scope.event"
    class="block p-t-12 p-x-16 md:p-t-16 lg:p-x-24"
  >
    <a
      yo-breadcrumb
      [routerLink]="[scope.homepageUrl]"
      i18n="@@videoBreadcrumbsHomeLabel"
      >Home</a
    >
    <a
      yo-breadcrumb
      [routerLink]="[scope.homepageUrl, 'events', scope.event.docId]"
    >
      {{ scope.event.title }}
    </a>
  </yo-breadcrumbs>

  <ng-container *ngIf="canBeRendered">
    <section class="video__wrapper m-t-16 md:m-x-16 lg:m-x-24">
      <ng-container *ngTemplateOutlet="videoAreaTmp"></ng-container>
    </section>

    <section
      class="flex flex-column gap-64 standard-margins m-t-40 md:m-t-16 lg:m-t-24"
    >
      <ng-container *ngTemplateOutlet="videoMetaTmp"></ng-container>
      <ng-container *ngTemplateOutlet="relatedVideosTmp"></ng-container>
    </section>
  </ng-container>

  <ng-template #videoAreaTmp>
    <ng-container *ngIf="!errorState; else pageErrorTmp">
      <section
        class="video__player--container w-100 md:w-80 lg:w-100"
        [ngClass]="{
          'with-video-state':
            !accessStatus?.access ||
            (accessStatus?.access && scope.video.streamState === 'SCHEDULED')
        }"
      >
        <ng-container
          *ngIf="accessStatus?.access; then videoPlayerTmp; else defaultViewTmp"
        ></ng-container>
      </section>

      <ng-container *ngIf="scope.prevAndNext$ | async as prevAndNext">
        <joymo-video-control
          *ngIf="prevAndNext.prev"
          data-control="prev"
          class="video__player--control video__player--control-previous block"
          [video]="prevAndNext.prev"
          direction="LEFT"
          [linkLabel]="previousVideoLinkLabel"
          [channel]="scope.channel"
        ></joymo-video-control>
        <joymo-video-control
          *ngIf="prevAndNext.next"
          data-control="next"
          class="video__player--control video__player--control-next block"
          [video]="prevAndNext.next"
          direction="RIGHT"
          [linkLabel]="nextVideoLinkLabel"
          [channel]="scope.channel"
        ></joymo-video-control>
      </ng-container>
    </ng-container>
  </ng-template>

  <ng-template #videoMetaTmp>
    <joymo-description-block
      [title]="scope.video.name"
      [description]="scope.video.description"
      class="video__meta"
    >
      <span
        joymo-desc-block-meta
        class="video__meta--date text-sm text-secondary"
      >
        {{
          scope.video.startTime || scope.video.uploadTime
            | date : 'dd MMM YYYY • HH:mm'
        }}
      </span>
      <div joymo-desc-block-action class="md:p-l-24 flex flex-column gap-24">
        <joymo-tags-list
          *ngIf="scope.tagsModule"
          [moduleData]="scope.tagsModule"
        ></joymo-tags-list>
        <joymo-help
          class="lg:w-50 p-16"
          [faqLink]="scope.channel.branding.contactInformation?.faqLink"
          [streamHelpText]="
            scope.channel.branding.contactInformation?.streamHelpText
          "
        ></joymo-help>
      </div>
    </joymo-description-block>
  </ng-template>

  <ng-template #relatedVideosTmp>
    <ng-container *ngIf="showEventLiveUpcoming">
      <joymo-live-and-upcoming
        class="block p-y-16"
        *ngIf="scope.liveAndUpcoming"
        [moduleData]="scope.liveAndUpcoming"
        [filterPredicate]="scope.filterPredicate"
        (noResults)="showEventLiveUpcoming = false"
      >
      </joymo-live-and-upcoming>
    </ng-container>
    <ng-container *ngIf="showChannelVideoList">
      <joymo-videos-list
        class="block p-y-16"
        [moduleData]="videoListForChannel"
        [filterPredicate]="scope.filterPredicate"
        (noResults)="showChannelVideoList = false"
      ></joymo-videos-list>
    </ng-container>
  </ng-template>

  <ng-template #videoPlayerTmp>
    <ng-container *ngIf="video$ | async as video">
      <ng-container [ngSwitch]="video.streamState">
        <ng-container *ngSwitchCase="'SCHEDULED'">
          <ng-container *ngTemplateOutlet="defaultViewTmp"></ng-container>
        </ng-container>

        <ng-container *ngSwitchDefault>
          <joymo-video-player
            class="w-100"
            [video]="video"
            [event]="scope.event"
            [analyticsContextData]="
              accessStatus && accessStatus.access
                ? accessStatus.playerContext
                : undefined
            "
            (videoStarted)="
              videoPlayerTrigger$.next({
                trigger: 'PLAY',
                time: $event.getTime()
              })
            "
            (videoPaused)="
              videoPlayerTrigger$.next({
                trigger: 'PAUSE',
                time: $event.getTime()
              })
            "
            (videoStopped)="
              videoPlayerTrigger$.next({
                trigger: 'STOP',
                time: $event.getTime()
              })
            "
            (fullScreenChange)="isPlayerInFullScreen$.next($event)"
          >
          </joymo-video-player>
          <ng-container *ngTemplateOutlet="socialFooterTmp"></ng-container>
        </ng-container>
      </ng-container>
    </ng-container>
    <ng-container
      *ngIf="scope.canProvideFeedback; then feedbackTmp"
    ></ng-container>
  </ng-template>

  <ng-template #defaultViewTmp>
    <img
      (error)="invalidPosterImage = true"
      [hidden]="invalidPosterImage"
      [src]="scope.video.posterImage"
      class="video__player--player block w-100"
    />
    <span
      *ngIf="!scope.video.posterImage || invalidPosterImage"
      class="block w-100 video__player--placeholder"
    ></span>
    <ng-container *ngIf="!isServer; then videoStateTmp"></ng-container>
  </ng-template>

  <ng-template #videoStateTmp>
    <joymo-video-state
      class="video__player--container-state"
      *ngIf="{ user: user$ | async } as stateCtx"
      (getAccessClicked)="
        openTicketOptions(
          scope.channel,
          scope.video,
          scope.event,
          stateCtx.user,
          accessStatus
        )
      "
      (streamStartingSoon)="isAboutToStart$.next($event)"
      [cheapestAccess]="scope.cheapestAccess"
      [hasAccess]="accessStatus ? accessStatus.access : false"
      [isAccessInactive]="
        !accessStatus || accessStatus.access
          ? false
          : accessStatus.isSubscriptionPaused
      "
      [loading]="state === 'loading'"
      [video]="scope.video"
    ></joymo-video-state>
  </ng-template>

  <ng-template #pageErrorTmp>
    <joymo-info-block
      *ngIf="errorState"
      class="video__error flex flex-align-center"
      [actionLabel]="errorState.details.actionLabel"
      [description]="errorState.details.description"
      [heading]="errorState.details.title"
      [icon]="errorState.details.icon"
      (onActionClick)="handleErrorStateAction(scope, errorState.reason)"
      [skipMobileRounding]="true"
    >
    </joymo-info-block>
  </ng-template>

  <ng-template #feedbackTmp>
    <joymo-video-feedback
      *ngIf="accessStatus"
      [video]="scope.video"
      [event]="scope.event"
      [channel]="scope.channel"
      [userAccessType]="
        accessStatus.access ? accessStatus.accessType : undefined
      "
      [videoPlayerTrigger$]="videoPlayerTrigger$"
      [isPlayerInFullScreen$]="isPlayerInFullScreen$"
    ></joymo-video-feedback>
  </ng-template>

  <!-- Duplicated in video-state.component.html -->
  <ng-template #socialFooterTmp>
    <div *ngIf="showBrowserRecommendation" class="p-4">
      <joymo-info-block
        type="WARNING"
        heading="For the best viewing experience, we recommend Google Chrome"
        size="sm"
      ></joymo-info-block>
    </div>

    <footer class="flex p-12 flex-justify-center">
      <joymo-social-share
        [shareTitle]="scope.video.name"
        [shareDescription]="scope.video.description"
        [showSupportMessage]="isMobile"
      ></joymo-social-share>
    </footer>
  </ng-template>
</ng-container>
